import { getErrorMessage } from "../locales/translationUtils";
import api from "./api";

export const postExportList = async (type: string, filters: any) => {
    try {
        const url: string = `/CargoInfo/report`;

        // Exportação (CSV/XLS/PDF) deve sempre trazer o dataset completo, independente
        // da paginação/ordenação usada na grid. O backend usa o mesmo FindByFilter tanto
        // para a grid quanto para a exportação, então precisamos remover/neutralizar aqui
        // qualquer parâmetro de paginação vindo do estado compartilhado da tela (senão o
        // export ficaria limitado à página atual da grid).
        const { pageNum, quantityPerPage, paginated, sort, order, ...exportFilters } = filters ?? {};

        const params = new Map<string, string>();
        for (const key of Object.keys(exportFilters)) {
            if (exportFilters[key] !== undefined && exportFilters[key] !== null && exportFilters[key] !== '') {
                params.set(key, String(exportFilters[key]));
            }
        }
        params.set('paginated', 'false');
        if (sort) {
            params.set('paginacao.sort', String(sort));
        }
        if (order) {
            params.set('paginacao.order', String(order));
        }

        const query = new URLSearchParams(params as unknown as Record<string, string>).toString();

        return await api.get(`${url}/${type}?${query}`, {
            headers: {
                Accept: 'application/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf'
            },
            responseType: 'blob'
        });
    } catch (error) {
        console.error(getErrorMessage("fetchExportListError", {}));
        throw error;
    }
};
